import { RefObject, useCallback, useEffect, useRef } from 'react';

interface UseInfiniteScrollOptions {
    rootRef?: RefObject<Element | null>;
    rootMargin?: string;
    threshold?: number;
}

export const useInfiniteScrollNew = (
    callback: () => void,
    { rootRef, rootMargin = '0px', threshold = 1.0 }: UseInfiniteScrollOptions = {}
) => {
    const observer = useRef<IntersectionObserver | null>(null);
    const lastElementRef = useRef<HTMLDivElement | null>(null);

    const setLastElement = useCallback(
        (node: HTMLDivElement | null) => {
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        callback();
                    }
                },
                {
                    root: rootRef?.current ?? null,
                    rootMargin,
                    threshold,
                }
            );

            if (node) {
                observer.current.observe(node);
            }

            lastElementRef.current = node;
        },
        [callback, rootMargin, rootRef, threshold]
    );

    useEffect(
        () => () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        },
        []
    );

    return setLastElement;
};
